const playList = [
  "https://jetsetradio.live/radio/stations/lofi/90sFlav - Balmy.mp3",
  "https://jetsetradio.live/radio/stations/lofi/90sFlav - Call Me.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Adam Kay - Rehab (Instrumental).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Aekasora - almost there.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Afternoon - spring (w park bird).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Aftrthght - I Think Of You When I Walk Alone.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Altitude - lake serene.mp3",
  "https://jetsetradio.live/radio/stations/lofi/App - Meaning to Call (5 Centimeters Per Second).mp3",
  "https://jetsetradio.live/radio/stations/lofi/App - My First.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Aqualina - Love Letters W-eiiwun.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Aso - Coffee.mp3",
  "https://jetsetradio.live/radio/stations/lofi/athena - one side..mp3",
  "https://jetsetradio.live/radio/stations/lofi/Bassti - To all the ladies in the place.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Bknapp - Game Over (Super Mario Lofi).mp3",
  "https://jetsetradio.live/radio/stations/lofi/blvknight - decembr.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Burbank - A Beautiful Name.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Burbank - Moonlights.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Burbank - The Shadow Of Your Smile.mp3",
  "https://jetsetradio.live/radio/stations/lofi/cat naps - hazy dreams.mp3",
  "https://jetsetradio.live/radio/stations/lofi/chief - dozing off with less people.mp3",
  "https://jetsetradio.live/radio/stations/lofi/city girl - walking in the rain to a cafe.mp3",
  "https://jetsetradio.live/radio/stations/lofi/cormac - summer wind.mp3",
  "https://jetsetradio.live/radio/stations/lofi/DDA - Hip Hop Sample.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Delayde - Sekao.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Desired - 18 Make Up.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Desired - Old Tape.mp3",
  "https://jetsetradio.live/radio/stations/lofi/DJ Cutman - Ballad of the Wind Fish (MeowMeow & BowWow).mp3",
  "https://jetsetradio.live/radio/stations/lofi/DJ Cutman - Meet at the Crossroads (Persona 5 Remix).mp3",
  "https://jetsetradio.live/radio/stations/lofi/DJ Shadow - Why hip hop sucks in 96.mp3",
  "https://jetsetradio.live/radio/stations/lofi/DLJ - The Place (Feat J'san).mp3",
  "https://jetsetradio.live/radio/stations/lofi/DOMINANT - birthday pt 20.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Dontcry - Moon.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Dontcry & Nokiaa - Misunderstood.mp3",
  "https://jetsetradio.live/radio/stations/lofi/driver - the eye of truth.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Dubvalentino - Pleasure.mp3",
  "https://jetsetradio.live/radio/stations/lofi/elijah who - uber to your place.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Eric Godlow Beats - Hopeful.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Falcxne - Beachside Dreaming.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Fallen Roses - Guilty Pleasures (feat. Greco).mp3",
  "https://jetsetradio.live/radio/stations/lofi/flowers - in love with a ghost (feat. nori).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Frad - The Girl I Have A Crush On.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Fujitsu - Motions.mp3",
  "https://jetsetradio.live/radio/stations/lofi/furino - Medusas.mp3",
  "https://jetsetradio.live/radio/stations/lofi/GentleBeatz - Silent Thoughts.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Hakaisu - Shelter (ft Alys).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Halberd - Nvm.mp3",
  "https://jetsetradio.live/radio/stations/lofi/hisohkah - bike ride.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Hm Surf  - Sid's Lesson.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Ibrahim - Bullet Train Fantasy (w luvbird).mp3",
  "https://jetsetradio.live/radio/stations/lofi/ibrahim - enamored (Feat Limes).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Ibrahim - Watermelon Slices.mp3",
  "https://jetsetradio.live/radio/stations/lofi/ImpOrtMediA - long time.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Invention Kartographer - Unknown.mp3",
  "https://jetsetradio.live/radio/stations/lofi/J. Cole x Russ Type Beat - Exotic (Prod. Syndrome).mp3",
  "https://jetsetradio.live/radio/stations/lofi/j'san - delusion.mp3",
  "https://jetsetradio.live/radio/stations/lofi/J'san - In Time.mp3",
  "https://jetsetradio.live/radio/stations/lofi/J'san - The Best Moment.mp3",
  "https://jetsetradio.live/radio/stations/lofi/j'san x Cloudchord - First Wonder.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Jinsang - Bright.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Jinsang - Flow On.mp3",
  "https://jetsetradio.live/radio/stations/lofi/jinsang - slumpin.mp3",
  "https://jetsetradio.live/radio/stations/lofi/jinsang - Summer's Day (v2).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Joakim Karud - Dreams.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Joe Corfield - Cheat Sheet.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Kael - We were so in love.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Kavv - Glistens.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Kavv - Now That You're Gone.mp3",
  "https://jetsetradio.live/radio/stations/lofi/konteks - mellow out.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Konteks - Rainy Day Daydream.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Konteks - The Moon In A Silver Bag.mp3",
  "https://jetsetradio.live/radio/stations/lofi/KRN 92 - Nimbus.mp3",
  "https://jetsetradio.live/radio/stations/lofi/krylic - Notorious.mp3",
  "https://jetsetradio.live/radio/stations/lofi/kudasai - a light of mine.mp3",
  "https://jetsetradio.live/radio/stations/lofi/kudasai - dream of her (the girl next door flip).mp3",
  "https://jetsetradio.live/radio/stations/lofi/kudasai - the girl i haven't met.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Kudasai & Luv.ly - Paradise.mp3",
  "https://jetsetradio.live/radio/stations/lofi/kudasai & two sleepy - fortune.mp3",
  "https://jetsetradio.live/radio/stations/lofi/L'indecis - Le Sud.mp3",
  "https://jetsetradio.live/radio/stations/lofi/L'indecis - Soulful.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LAKEY INSPIRED - Chill Day.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lee - I Need A girl.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Letskey - Memories.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lily Potter - Oblivion.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LJones - Chihiro's Break.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lo'Fi Boy - Little Love Song.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lo'Fi Boy - LOTUS (Feat. The Girl Next Door).mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Always Sad.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Coffee on the beach.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Daybreak (Original Mix).mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Feelings Fade And People Change.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Forever.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Hold Me.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - I Am Sad In My Room Once Again.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Moonlight.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Optimistic.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Rain.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lofi - The happy moments come often but so do the painful ones.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Together.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Using My Heart Less.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoFi - Wish I'd Stayed.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lonely - Moving On.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lost Son - luv loop.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lost Son - Oh Look, It's Raining Again.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Lovebird - February.mp3",
  "https://jetsetradio.live/radio/stations/lofi/LoveLord - Jus' Chillin (Instrumental).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Made In M - Mirror.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Masked Man - Cloudy Dreams.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Medda - Flower Fields.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Medda - Temporary.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Medda - you're always there.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Mewsyc - I'm never good enough.mp3",
  "https://jetsetradio.live/radio/stations/lofi/mommy - passing.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Mono Massive - Attila.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Mt Fujitive - Leaves.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Neeks - summer awaits (feat. sad boy with a laptop).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Nicobox - Morning Jazz.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Nochi - Warm Stares.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Nuxe & Zaini - Like U (ft. b o b b i e).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Nymano - Women.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Omar - Serene.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Omarr - Chai.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Omarr - Good Morning.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Pandrezz - by the bridge at night (feat. nohone).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Pheeno - Rest.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Porou - Sweet Dreams Love.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Potsu - CHAM.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Potsu - losing sight.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Potsu - Oops.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Prima - June Gloom.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Probe - Stardust Walkway (Sonic Lofi).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Redpest - Sleepy Time Beats.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Rook1e - I Fell In Love With You One Night In September.mp3",
  "https://jetsetradio.live/radio/stations/lofi/RUDE - Eternal Youth.mp3",
  "https://jetsetradio.live/radio/stations/lofi/sad boy with a laptop - evergreen.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sad Boy With A Laptop - I Was Lost Until I Met You.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sad Boy With A Laptop - Portals To Mystical Worlds.mp3",
  "https://jetsetradio.live/radio/stations/lofi/sad boy with a laptop - you were so far away.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Saik - Wet Season.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Saiko - Sofia Drift.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sarcastic Sounds - I Don't Sleep.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sarcastic Sounds & Ezra - Thinking Of You.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Satin - Unknown.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sinh - Poetry (Feat Natty Reeves).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sleepdealer - Naturals.mp3",
  "https://jetsetradio.live/radio/stations/lofi/slipfunc - a spring without you.mp3",
  "https://jetsetradio.live/radio/stations/lofi/smuv - looped.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sonic Lofi - Green Chill Zone.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Sonic Lofi - Low Spec Robo Go.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Splatoon 2 Octo Expansion - 8-Ball LoFi Hip Hop Remix.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Super Mario World - Game Over LoFi Hip Hop Remix.mp3",
  "https://jetsetradio.live/radio/stations/lofi/SURF - Instant Brew.mp3",
  "https://jetsetradio.live/radio/stations/lofi/SURF - Take Care.mp3",
  "https://jetsetradio.live/radio/stations/lofi/THAIBEATS - Faithful.mp3",
  "https://jetsetradio.live/radio/stations/lofi/The Deli - 5-32PM.mp3",
  "https://jetsetradio.live/radio/stations/lofi/The Deli - Flowers.mp3",
  "https://jetsetradio.live/radio/stations/lofi/the girl next door - come chill with me on some floating tropical island.mp3",
  "https://jetsetradio.live/radio/stations/lofi/the girl next door - the girl i once loved.mp3",
  "https://jetsetradio.live/radio/stations/lofi/through & through - blueberry jet.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Treycitybeatz - Sonic Vibes.mp3",
  "https://jetsetradio.live/radio/stations/lofi/TV Blonde - Ocarina.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Tymu - Walk With Me.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Tysu - White Cherry (Feat Tenpo).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Call me.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Couch Day (Original Mix).mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Easy.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Fools Paradise.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Home Before The Storm.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Imagine.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - It Happens.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Light Strands.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Long Talks.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Unknown - Time Stands Still.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Video Game LoFi - DK Rap To Relax and Study To.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Video Game LoFi - Grand Theft Auto III.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Video Game LoFi - Ocarina of Time.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Walterwarm - Do It For You.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Ward Wills - La Cafeteria.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Wunsche - Flower.mp3",
  "https://jetsetradio.live/radio/stations/lofi/wunsche - patience.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Wunsche - Soulfood.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Yusei - Do You Ever Miss The Old You.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Yusei - I Was All About You.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Zeeky Beats - Beside You.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Zeeky Beats - Dream or Reality.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Zeeky Beats - Follow Her.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Zeeky Beats - Fresh Air.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Zeeky Beats - Gone For Now.mp3",
  "https://jetsetradio.live/radio/stations/lofi/Zeeky Beats - Missed Calls.mp3",
];

export default playList;